import DropdownSelect from "@components/WebsiteRevamp/Dropdown/DropdownSelect"
import Typography, {Size} from "@components/WebsiteRevamp/Typography/Typography"
import SignInIcon from "@components/icons/SignInIcon"
import React from "react"

import styles from "./LoginSelect.module.scss"
import Image from "next/image"

type Props = {
	isShown: number
	setIsShown: (id: number) => void
	activeContext?: "desktop" | "mobile"
}

const LoginSelect: React.FC<Props> = ({
	isShown,
	setIsShown,
	activeContext = "desktop",
}) => {
	const options = [
		{
			key: "studio",
			render: (
				<a
					href={"https://dreambroker.com/studio/login"}
					target={"__blank"}
					className={`${styles.optionBox} ${styles.studio}`}>
					{/* <div>
						Studio */}
					<Image
						className={styles.LogoImage}
						src={"/Group-2586.svg"}
						width={50}
						height={18}
						alt="Drem Broker Studio Logo login"
					/>
					{/* </div> */}
					{/* <SignInIcon className={styles.svgIcon} /> */}
				</a>
			),
		},
		{
			key: "one",
			render: (
				<a
					href={"https://app.one.dreambroker.com/"}
					target={"__blank"}
					className={`${styles.optionBox} ${styles.one}`}>
					<Image
						className={styles.LogoImage}
						src={"/Product-Logo-7.svg"}
						width={50}
						height={18}
						alt="Drem Broker #One Logo login"
					/>
					{/* <SignInIcon className={styles.svgIcon} /> */}
				</a>
			),
		},
	]

	return (
		<DropdownSelect
			id={-2}
			isShown={isShown}
			setIsShown={setIsShown}
			options={options}
			buttonContent={
				<Typography
					content={"Sign in"}
					fontWeight={700}
					size={Size.XS}
					noPadding
				/>
			}
			activeContext={activeContext}
			menuClassName={styles.selectMenu}
			optionClassName={styles.option}
		/>
	)
}

export default LoginSelect
